import { axiosClient } from "services/axios";

import {
  TDocItem,
  TDocItemsFilters,
  TDocument,
  TDocumentsFilters,
} from "../../../types/documents";
import { Item } from "../../../types";

export function getDocumentsRequest(obj: TDocumentsFilters = {}) {
  return axiosClient
    .get("documents/documents/", {
      params: obj,
    })
    .then((res) => res.data as TDocument[])
    .catch((e) => console.warn(e?.message, "while getting documents"));
}

export function createDocumentRequest(obj: { operation_id: string }) {
  return axiosClient
    .post("documents/document/", obj)
    .then((res) => res.data as TDocument)
    .catch((e) => console.warn(e?.message, "while creating document"));
}

export function updateDocumentRequest(obj) {
  return axiosClient
    .put("documents/document/", obj)
    .then((res) => res.data as TDocument)
    .catch((e) => console.warn(e?.message, "while updating document"));
}

export function deleteDocumentsRequest(obj: { docids: string[] }) {
  return axiosClient
    .post("documents/delete-documents/", obj)
    .then((res) => res.data as { message: "success" | string })
    .catch((e) => console.warn(e?.message, "while deleting documents"));
}

export function conductDocumentsRequest(obj: { docids: string[] }) {
  return axiosClient
    .post("documents/conduct/", obj)
    .then(
      (res) =>
        res.data as { message: "success" | string; errorMessages: string[] }
    )
    .catch((e) => console.warn(e?.message, "while conducting documents"));
}

export function unConductDocumentsRequest(obj: { docids: string[] }) {
  return axiosClient
    .post("documents/unconduct/", obj)
    .then((res) => res.data as { message: "success" | string })
    .catch((e) => console.warn(e?.message, "while un conducting documents"));
}

export function getItemsLeftAmountRequest(obj: {
  itemGroupIds: string[];
  docId: string;
}) {
  return axiosClient
    .post("documents/get-left-amount/", obj)
    .then((res) => res.data as Item[])
    .catch((e) => console.warn(e?.message, "while getting items left amount"));
}

/* ================ Doc Items ================*/
export function getDocItemsRequest(obj: TDocItemsFilters = {}) {
  return axiosClient
    .get("documents/get-docitems/", {
      params: obj,
    })
    .then((res) => res.data as TDocItem[])
    .catch((e) => console.warn(e?.message, "while getting doc items"));
}

export function createDocItemsRequest(obj: { docitems: TDocItem[] }) {
  return axiosClient
    .post("documents/create-docitems/", obj)
    .then((res) => res.data as { message: "success" | string })
    .catch((e) => console.warn(e?.message, "while creating doc items"));
}

export function updateDocItemsRequest(obj: { docitems: TDocItem[] }) {
  return axiosClient
    .put("documents/update-docitems/", obj)
    .then((res) => res.data as { message: "success" | string })
    .catch((e) => console.warn(e?.message, "while updating doc items"));
}

export function deleteDocItemsRequest(obj: {
  docitemids: string[];
  docid: string;
}) {
  return axiosClient
    .post("documents/delete-docitems/", obj)
    .then((res) => res.data as { message: "success" | string })
    .catch((e) => console.warn(e?.message, "while deleting doc items"));
}

export function duplicateDocumentRequest(obj: {
  docid: string;
  newDocType: string;
}) {
  return axiosClient
    .post("documents/duplicate/", obj)
    .then((res) => res.data as TDocument)
    .catch((e) => console.warn(e?.message, "while duplicating document"));
}

export function getItemLeftAmountRequest(obj: {
  itemid: string;
  docid: string;
}) {
  return axiosClient
    .get("items/left-amount/", {
      params: obj,
    })
    .then((res) => res.data as number)
    .catch((e) => console.warn(e?.message, "while getting item left amount"));
}
